
<div class="container-nm px-4 pt-4 w-100 mx-auto step_mobile" style="box-sizing: border-box;">
    <div class="title-page">
        <span>{{ 'stenOne.txtTitle' | translate }}</span>
    </div>
    <div class="line"></div>
    <div class="description-page">
        <span>{{ 'stenOne.txtDescription' | translate }}</span>
    </div>
    <div class="d-flex mx-auto justify-content-center align-items-center flex-wrap mobile-not-active">
        <div class="d-flex flex-column justify-content-center align-items-center gap-3 shadowBl" (click)="goToCreateGame()">            
            <div class="icon">
                <img src="./assets/slot.png" />
            </div>
            <span>{{ 'stenOne.txtOnOnesOwn' | translate }}</span>
        </div>
        <div class="d-flex flex-column justify-content-center align-items-center gap-3 shadowBl" (click)="goToStepTwo()">
            <div class="icon">
                <img src="./assets/slot_1.png" />
            </div>
            <span>{{ 'stenOne.txtTeams' | translate }}</span>
        </div>
    </div>
    
    <div class="d-flex mx-auto justify-content-center align-items-start mt-3 mobile-not-active" id="blockDescrGame">
        <div class="d-flex justify-content-center align-items-center block-info-game" [style]="{'min-height': `${blockMinHeight()}px`}">
            <span>
                {{ 'stenOne.txtTextL' | translate }}
            </span>
        </div>
        <div class="d-flex justify-content-center align-items-center block-info-game" [style]="{'min-height': `${blockMinHeight()}px`}">
            <span>
                {{ 'stenOne.txtTextR' | translate }}
            </span>
        </div>
    </div>

    <div class="mobile-active">
        <mat-tab-group [(selectedIndex)]="selectedTabIndex">
            <mat-tab label="{{ 'stenOne.txtTabOne' | translate }}">
                <div class="p-3 d-flex flex-column justify-content-center align-items-center gap-3 shadowBl mt-3">            
                    <div class="icon">
                        <img src="./assets/slot.png" />
                    </div>
                    <span>{{ 'stenOne.txtOnOnesOwn' | translate }}</span>
                </div>
                <div class="p-3 d-flex justify-content-center align-items-center block-info-game mt-2">
                    <span>
                        {{ 'stenOne.txtTextL' | translate }}
                    </span>
                </div>
            </mat-tab>
            <mat-tab label="{{ 'stenOne.txtTabMulti' | translate }}">
                <div class="p-3 d-flex flex-column justify-content-center align-items-center gap-3 shadowBl mt-3">
                    <div class="icon">
                        <img src="./assets/slot_1.png" />
                    </div>
                    <span>{{ 'stenOne.txtTeams' | translate }}</span>
                </div>
                <div class="p-3 d-flex justify-content-center align-items-center block-info-game mt-2">
                    <span>
                        {{ 'stenOne.txtTextR' | translate }}
                    </span>
                </div>
            </mat-tab>
        </mat-tab-group>
        <button type="button" class="d-flex justify-content-center align-items-center gap-2 btn-next mt-3" (click)="goToNextRoom()">
            <span>{{ 'buttons.txtNext' | translate }}</span>
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14 18L12.6 16.55L16.15 13H4V11H16.15L12.6 7.45L14 6L20 12L14 18Z" fill="white"/>
            </svg>
        </button>
    </div>
    
</div>

<!-- <app-experiment></app-experiment> -->
